module.exports = __webpack_public_path__ + "static/img/头像2.0a068264.png";